import { render } from "./TipTap.vue?vue&type=template&id=182b8262"
import script from "./TipTap.vue?vue&type=script&lang=js"
export * from "./TipTap.vue?vue&type=script&lang=js"

import "./TipTap.vue?vue&type=style&index=0&id=182b8262&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__